import { ArrowBack } from '@mui/icons-material/'
import { Typography, Button } from '@mui/material'
import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'

type GoBackProps = {
  onClick: () => void
}

const GoBackButton = ({ onClick }: GoBackProps) => {
  const { t } = useTranslation()
  return (
    <Button
      aria-label={t('goBackAria')}
      onClick={onClick}
      sx={{
        background: 'transparent',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        color: theme.palette.text.secondary,
        '&:hover': {
          color: theme.palette.text.primary,
          backgroundColor: 'transparent',
          svg: { fill: theme.palette.icon.hover },
        },
      }}>
      <ArrowBack />
      <Typography ml={1}>{t('back')}</Typography>
    </Button>
  )
}

export default GoBackButton
